import { IonContent, IonPage } from "@ionic/react";
import { Redirect } from "react-router";
import { useAppSelector } from "../../Hooks";
import { selectUser } from "../../reducers/UserReducer";
import { isStaff } from "../../components/extras/Functions";
import AlphaInsightsHeader from "../../components/AE2/AlphaInsightsHeader";
import ServiceEstimates from "../../components/AE2/ServiceEstimates/ServiceEstimates";
import { API_URL } from "../../actions/settings";
import { configureServiceEstimatesApi } from "../../utils/serviceEstimatesApi";

configureServiceEstimatesApi({
  baseUrl: `${API_URL}/service-estimates/`,
  getHeaders: async ()=> {
    const token = `Token ${(localStorage.getItem("token")||'').slice(1, -1)}`;
    return token ? { Authorization: token, Accept: "application/json" } : {};
  },
});


const ServiceEstimatesPage: React.FC = () => {
  const user = useAppSelector(selectUser);

  if (user.first_name !== "" && !isStaff(user)) {
    return <Redirect to="/403" />;
  }

  return (
    <IonPage className="ae2-home">
      <AlphaInsightsHeader />
      <IonContent className="bg-main">
        <ServiceEstimates />
      </IonContent>
    </IonPage>
  );
};

export default ServiceEstimatesPage;
